import { useTranslation } from "@outschool/localization";
import { useQueryWithPreviousData } from "@outschool/ui-apollo";
import _ from "lodash";
import React from "react";

import ListingsByActivityUidsQuery from "../graphql/ListingsByActivityUidsQuery";
import ListingCarousel from "./ListingCarousel";

export type ClassLinkType = {
  uid: string;
  title: string;
  isOrdered: boolean;
  bundleElements: BundleElementType[];
};

export type BundleElementType = {
  orderInBundle: number;
  activity: {
    uid: string;
  };
};

export function ClassLinkCarousel({
  classLink,
  currentActivityUid,
  carouselRowNum,
}: {
  classLink: ClassLinkType | null;
  currentActivityUid: string;
  carouselRowNum: number;
}) {
  const { t } = useTranslation(
    "ui-components-website\\src\\Listings\\Carousels\\ClassLinkCarousels"
  );
  const activityUids = _.sortBy(
    classLink?.bundleElements ?? [],
    el => el.orderInBundle
  ).map((el: BundleElementType) => el.activity.uid);
  const { data } = useQueryWithPreviousData(ListingsByActivityUidsQuery, {
    variables: {
      activityUids: activityUids,
      skipRating: false,
      withRecentReviews: false,
    },
  });

  if (!classLink || activityUids.length == 0) {
    return null;
  }

  return (
    <ListingCarousel
      // sx={{ padding: 0 }}
      listings={data?.listingsByActivityUids}
      title={t("Explore: {{title}}", { title: classLink.title })}
      trackingLabel="class links"
      carouselRowNum={carouselRowNum}
      currentIndex={activityUids.indexOf(currentActivityUid)}
      leftAlign
      headingSx={{ textAlign: "left" }}
    />
  );
}
